import { getRouteIdFromPathname, RouteId } from '@trello/router';

export const validateReturnUrl = (pathname: string) => {
  const routeId = getRouteIdFromPathname(pathname);
  return routeId === RouteId.TEMPLATES;
};
